// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1k8fU","image":"Header_image__2IR7r","name":"Header_name__1SIB4","info":"Header_info__y9jKi","infoRow":"Header_infoRow__MS0in"};